import localforage from 'localforage'
import VueJwtDecode from 'vue-jwt-decode'

export const termsAndConditions = {
    namespaced: true,
    state: {
        terms: '',
        status: 'initial',
        accepted: false
    },
    mutations: {
        SET_TERMS(state, payload) {
            state.terms = payload
        },
        SET_TERMS_STATUS(state, payload) {
            state.status = payload
        },
        SET_ACCEPTED(state, payload) {
            state.accepted = payload
        }
    },
    actions: {
        checkIfAccepted({ commit, rootGetters }) {
            commit('SET_TERMS_STATUS', null)
            commit('SET_TERMS_STATUS', 'checking if accepted')
            const isAccepted = VueJwtDecode.decode(rootGetters.authToken)
                .terms_of_use
            commit('SET_ACCEPTED', isAccepted)
            commit('SET_TERMS_STATUS', 'idle')
        },
        fetchTerms({ commit, state }) {
            commit('SET_TERMS_STATUS', null)
            commit('SET_TERMS_STATUS', 'loading')
            return this.$api
                .get('api/regulations/main.json')
                .then(response => {
                    commit('SET_TERMS', response.data.data)
                    commit('SET_TERMS_STATUS', 'idle')
                })
                .catch(error => {
                    commit('SET_TERMS_STATUS', 'error')
                    return Promise.reject(error)
                })
        },
        acceptTerms({ commit, dispatch, state }, payload) {
            commit('SET_TERMS_STATUS', null)
            commit('SET_TERMS_STATUS', 'sending')
            // accept terms
            return this.$api
                .post('api/regulations/accept.json', payload)
                .then(() => {
                    // fetch new token
                    return this.$api
                        .get('api/users/refresh-token.json')
                        .then(response => {
                            // set new token
                            commit('SET_AUTH_TOKEN', response.data.data.token, {
                                root: true
                            })
                            localforage
                                .setItem('authToken', response.data.data.token)
                                .then(() => {
                                    // send user id to OneSignal
                                    dispatch('sendExternalUserId', null, {
                                        root: true
                                    })
                                })
                        })
                })
                .catch(error => console.log({ error }))
        }
    },
    getters: {
        terms: state => state.terms,
        status: state => state.status,
        accepted: state => state.accepted
    }
}
